document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lang-tabs').forEach(function (tabGroup) {
    var buttons = tabGroup.querySelectorAll('.lang-tab-btn');
    var article = tabGroup.closest('.article-content') || document;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var lang = btn.getAttribute('data-lang');
        buttons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        article.querySelectorAll('.lang-content').forEach(function (c) {
          c.classList.remove('active');
        });
        article.querySelectorAll('.lang-' + lang).forEach(function (c) {
          c.classList.add('active');
        });
      });
    });
  });
});